import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Router from 'vue-router'
import * as XLSX from 'xlsx'
import login from '@/views/login/login'
import index from '@/views/index/index'
import register from '@/views/register/index'

import home from '@/views/index/home'
import lipinorder from '@/views/lipinOrder/index'

import dltg from '@/views/dltg/index'
import zctg from '@/views/dltg/zctg/index'
import yjlb from '@/views/dltg/yjlb/index'
import kmlb from '@/views/dltg/kmlb/index'
import txjl from '@/views/dltg/txjl/index'

import syncOrder from '@/views/syncOrder/index'
import autoSend from '@/views/syncOrder/autoSend/index'
import handSend from '@/views/syncOrder/handSend/index'
import plSend from '@/views/syncOrder/plSend/index'
import orders from '@/views/syncOrder/orders/index'
import xfjf from '@/views/syncOrder/xfjf/index'
import bind from '@/views/syncOrder/bind/index'
import sms from '@/views/syncOrder/sms/index'

import cwmx from '@/views/cwmx/index'
import czzx from '@/views/cwmx/czzx/index'
import czjl from '@/views/cwmx/czjl/index'
import xfjl from '@/views/cwmx/xfjl/index'
import hyjg from '@/views/cwmx/hyjg/index'
import wllog from '@/views/cwmx/wllog/index'
import payReturn from '@/views/cwmx/payReturn/index'

import zzc from '@/views/zzc/index'
import jianjie from '@/views/zzc/jianjie'
import zzcOrders from '@/views/zzc/orders'
import prices from '@/views/zzc/prices'
import claim from '@/views/zzc/claim'

import rypd from '@/views/yiyingyong/ruyipaidan/index'
import secondGenerationLogistics from '@/views/secondGenerationLogistics/index'
import queryPushTracking from '@/views/secondGenerationLogistics/queryPushTracking'
import selectOrderInfo from '@/views/secondGenerationLogistics/selectOrderInfo'
import pushPickCode from '@/views/secondGenerationLogistics/pushPickCode'

// import editInfo from '@/views/editInfo/index'
import horizontalScroll from 'el-table-horizontal-scroll'
Vue.use(horizontalScroll)

Vue.use(ElementUI)
Vue.use(Router)
Vue.use(XLSX)


export const constantRoutes = [
  {
    path: '/register',
    name: 'register',
    component: register
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/yiyingyong/ruyipaidan',
    name: 'rypd',
    component: rypd
  },
  {
    path: '/secondGenerationLogistics',
    name: 'secondGenerationLogistics',
    component: secondGenerationLogistics
  },
  {
    path: '/queryPushTracking',
    name: 'queryPushTracking',
    component: queryPushTracking
  },
  {
    path: '/selectOrderInfo',
    name: 'selectOrderInfo',
    component: selectOrderInfo
  },
  {
    path: '/pushPickCode',
    name: 'pushPickCode',
    component: pushPickCode
  },
  {
    path: '/index',
    name: 'index',
    component: index,
    children: [
      {
        path: '//',
        name: 'home',
        component: home,},
      
      {
        path: '/zzc',
        name: 'zzc',
        component: zzc,
        children: [
          {
            path: '/zzc/jianjie',
            name: 'jianjie',
            component: jianjie
          },
          {
            path: '/zzc/zzcOrders',
            name: 'zzcOrders',
            component: zzcOrders
          },
          {
            path: '/zzc/prices',
            name: 'prices',
            component: prices
          },
          {
            path: '/zzc/claim',
            name: 'claim',
            component: claim
          },
        ]
      },
      {
        path: '/lipinorder',
        name: 'lipinorder',
        component: lipinorder,
      },
      {
        path: '/cwmx',
        name: 'cwmx',
        component: cwmx,
        children: [
          {
            path: '/cwmx/czzx',
            name: 'czzx',
            component: czzx
          },
          {
            path: '/cwmx/czjl',
            name: 'czjl',
            component: czjl
          },
          {
            path: '/cwmx/xfjl',
            name: 'xfjl',
            component: xfjl
          },
          {
            path: '/cwmx/hyjg',
            name: 'hyjg',
            component: hyjg
          },
          {
            path: '/cwmx/wllog',
            name: 'wllog',
            component: wllog
          },
          {
            path: '/cwmx/payReturn',
            name: 'payReturn',
            component: payReturn
          },
        ]
      },
      {
        path: '/dltg',
        name: 'dltg',
        component: dltg,
        children: [
          {
            path: '/dltg/zctg',
            name: 'zctg',
            component: zctg
          },
          {
            path: '/dltg/yjlb',
            name: 'yjlb',
            component: yjlb
          },
          {
            path: '/dltg/kmlb',
            name: 'kmlb',
            component: kmlb
          },
          {
            path: '/dltg/txjl',
            name: 'txjl',
            component: txjl
          },
        ]
      },
      {
        path: '/syncOrder',
        name: 'syncOrder',
        component: syncOrder,
        children: [
          {
            path: '/syncOrder/autoSend',
            name: 'autoSend',
            component: autoSend
          },
          {
            path: '/syncOrder/handSend',
            name: 'handSend',
            component: handSend
          },
          {
            path: '/syncOrder/plSend',
            name: 'plSend',
            component: plSend
          },
          {
            path: '/syncOrder/orders',
            name: 'orders',
            component: orders
          },
          {
            path: '/syncOrder/xfjf',
            name: 'xfjf',
            component: xfjf
          },
          {
            path: '/syncOrder/bind',
            name: 'bind',
            component: bind
          },
          {
            path: '/syncOrder/sms',
            name: 'sms',
            component: sms
          },
        ]
    
      },
      // {
      //   path: '/editInfo',
      //   name: 'editInfo',
      //   component: editInfo,
      // },
    ]
  },
  // {
  //   path: '//',
  //   name: 'home',
  //   component: home,
  // },
  
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
  // mode: 'history'   //  updated in 1203
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js